import { useMutation } from '@apollo/client';
import { useNotifications } from '@sixfold/common-ui';
import { renderChildren, Children } from '@sixfold/typed-render-props';
import React from 'react';

import {
  UpdateCompanySignupStatusMutation as MutationType,
  UpdateCompanySignupStatusMutationVariables,
  UnifiedCompanySignupStatusUpdateInput,
} from '../../lib/graphql';
import { companyOnboardingQuery, updateCompanySignupStatusMutation } from '../graphql';

interface Props {
  children: Children<{
    updateCompanySignupStatus: (companyId: string, input: UnifiedCompanySignupStatusUpdateInput) => Promise<void>;
  }>;
}

export const UpdateCompanySignupStatusMutation: React.FunctionComponent<Props> = ({ children }) => {
  const notify = useNotifications();
  const [updateCompanySignupStatusMutate] = useMutation<MutationType, UpdateCompanySignupStatusMutationVariables>(
    updateCompanySignupStatusMutation,
  );

  return (
    <>
      {renderChildren(children as React.ReactNode, {
        updateCompanySignupStatus: async (companyId: string, input: UnifiedCompanySignupStatusUpdateInput) => {
          const response = await updateCompanySignupStatusMutate({
            refetchQueries: [
              {
                query: companyOnboardingQuery,
                variables: { company_id: companyId },
              },
            ],
            variables: {
              company_id: companyId,
              input,
            },
          });
          notify.success({ title: 'Company onboarding status updated' });
          return response;
        },
      })}
    </>
  );
};
